"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function makeUseEventHandler(BettingApiCtx) {
    return function (_a) {
        var eventType = _a.eventType;
        var bettingEvents = react_1.useContext(BettingApiCtx).bettingEvents;
        var _b = react_1.useState(bettingEvents.checkIsEventAvailable(eventType)), isEventAvailable = _b[0], setIsEventAvailable = _b[1];
        var dispatchBettingEvent = react_1.useCallback(function (opts) { return bettingEvents.dispatch(eventType, opts); }, [bettingEvents, eventType]);
        react_1.useEffect(function () {
            var sub = bettingEvents
                .checkIsEventAvailable$(eventType)
                .subscribe(setIsEventAvailable);
            return function () { return sub.unsubscribe(); };
        }, [bettingEvents, eventType]);
        return {
            isEventAvailable: isEventAvailable,
            dispatchBettingEvent: dispatchBettingEvent,
        };
    };
}
exports.default = makeUseEventHandler;
//# sourceMappingURL=makeUseEventHandler.js.map